export default "__VITE_ASSET__CvkcpnxJ__"